
export class PreviewData {
  submitterData: RenderPreview[] = new Array(new RenderPreview());
  nonSubmitterData: RenderPreview[] = new Array(new RenderPreview());
}
export class RenderPreview {
  data: FieldElement[] = new Array<FieldElement>(new FieldElement());
  displayquestion: string = '';
  qcount: number = 0;
  sectionId: string = '';
  shallRenderOnListItemsUI: boolean = false;
  nodeLogic: ConditionalLogic = new ConditionalLogic();
  answered: boolean | null = null;
  valid: boolean | null = null;
  isAnswerModified?: boolean = false;
  isLastNonSubmitterItem?: boolean = false;
}

export class ConditionalLogic {
  id: string = '';
  isCondition: boolean = false;
  mandatory: boolean = false;
  name: string = '';
  navigate: Navigation[] = new Array(new Navigation());
  next: string[] = [''];
  scoring: string = '';
  seq: number = 0;
  validation: any[] = [];
  parentid?: string = '';
  selectedAnswers?: string[] = [''];
  previous?: string[] = [''];
}

export class Navigation {
  condition: string = '';
  isScoreEnabled: boolean = false;
  mandatoryNodes: string[] = [''];
  next: string[] = [''];
  score: string = '';
}

export class FieldElement {
  question: Question = new Question();
  questionlabel?: Question = new Question();
  questionInput?: Question = new Question();
  QuestionId: string = '';
  displayText: string = '';
  type: string = '';
  value?: string = '';
  isShortText?: boolean;
  dispalyFCText?: string = '';
  mouseOverText?: string = '';
  mappableCheck?: boolean = false;
  dataExpression: number = 0;
  TypeValue?: string = '';
  textboxdata?: any[] = [];
  dropdowndata?: any[] = [];
  multiselectDropdowndata?: any[] = [];
  checkboxdata?: any[] = [];
  radiodata?: any[] = [];
  alignment?: string = '';
  inputType?: string = '';
  isHidden?: boolean = false;
  isDisableInputChecked?: boolean = false;
  isDefaultValueChecked?: boolean = false;
  isBetweenSelected?: boolean = false;
  isFutureDateAllowed?: boolean = false;
  minPastMonth?: number = 0;
  maxFutureMonth?: number = 0;
  minLength?: string = '';
  maxLength?: string = '';
}

export class Question {
  changingThisBreaksApplicationSecurity: string = '';
}

export class PreviewQuestionAnswerDetailsSaved {
  modifiedField: any | null = null;
  answerUniqueId: string[] = [''];
  answerValue: any[] | null = null;
  isAnswerValid: boolean = false;
  isAnswerModified?: boolean = false;
}

export class QuestionDetails {
  questionId: string = '';
  questionName: string = '';
}

export class Label {
  faIconClass: string = '';
  infoText: string = '';
}

export class FormDataPayload {
  id?: string = '';
  question?: string = '';
  answers?: string[] = [''];
}
export class SaveSurveyPayload {
  id?: string = '';
  question?: string = '';
  answers?: string = '';
}

export interface IUserSavedAnswer {
  SourceSectionUniqueID?: string;
  SourceUniqueID?: string;
  SourceTypeName?: string;
  SourceTypeValue?: string;
  SourceEncrypted?: boolean;
  UniqueID?: string;
  Value?: string;
  ValueRef?: string;
  Files?: any;
}

export interface IDropdownData {
  id: number;
  optionid: string;
  answer: string;
  selected: boolean;
}
